import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { ProdutosDTO } from '../../../models/produto.models';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-dashboard-estoque',
  templateUrl: './dashboard-estoque.component.html',
  styleUrls: ['./dashboard-estoque.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DashboardEstoqueComponent implements OnInit, OnDestroy {

  @Input() produtos: ProdutosDTO[] = [];
  @Input() loading = false;

  // Dialog de estoque limitado
  showDialogEstoque = false;
  produtosDialog: ProdutosDTO[] = [];

  // Imagem
  env = environment;
  idEmpresa = '';
  imagensComErro: { [id: number]: boolean } = {};

  texts = {
    estoque_limitado: '',
    ver_todos: '',
    nome_produto: '',
    quantidade: '',
    fechar: '',
    preco_compra: '',
    preco_venda: '',
    estoque_minimo: '',
    codigo: '',
    produto: '',
    compra: '',
    venda: '',
    minimo: '',
    sem_imagem: ''
  };

  private langChangeSub!: Subscription;

  constructor(
    private translate: TranslateService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.idEmpresa = sessionStorage.getItem('id') || '';
    this.loadTranslations();
    this.langChangeSub = this.translate.onLangChange.subscribe(() => {
      this.loadTranslations();
      this.cdr.markForCheck();
    });
  }

  ngOnDestroy(): void {
    if (this.langChangeSub) {
      this.langChangeSub.unsubscribe();
    }
  }

  abrirDialogEstoque(): void {
    this.produtosDialog = [...this.produtos];
    this.imagensComErro = {};
    this.showDialogEstoque = true;
  }

  produtoTemImagemValida(produto: ProdutosDTO): boolean {
    return !!produto.imagem && produto.imagem.trim().length > 0 && !this.imagensComErro[produto.id!];
  }

  getImagemUrl(imagem: string): string {
    return `${this.env.imgHost}/${this.idEmpresa}/item/${imagem}`;
  }

  onImageError(produto: ProdutosDTO): void {
    if (produto.id) {
      this.imagensComErro[produto.id] = true;
    }
  }

  irParaProduto(produto: ProdutosDTO): void {
    if (produto.id) {
      this.showDialogEstoque = false;
      this.router.navigate(['/produtos'], { queryParams: { edit: produto.id } });
    }
  }

  trackByProdutoId(index: number, produto: ProdutosDTO): number | undefined {
    return produto.id;
  }

  private loadTranslations(): void {
    this.texts = {
      estoque_limitado: this.translate.instant('dashboard.texts.estoque_limitado'),
      ver_todos: this.translate.instant('dashboard.texts.ver_todos'),
      nome_produto: this.translate.instant('dashboard.texts.nome_produto'),
      quantidade: this.translate.instant('dashboard.texts.quantidade'),
      fechar: this.translate.instant('dashboard.texts.fechar'),
      preco_compra: this.translate.instant('dashboard.texts.preco_compra'),
      preco_venda: this.translate.instant('dashboard.texts.preco_venda'),
      estoque_minimo: this.translate.instant('dashboard.texts.estoque_minimo'),
      codigo: this.translate.instant('dashboard.texts.codigo'),
      produto: this.translate.instant('dashboard.texts.produto'),
      compra: this.translate.instant('dashboard.texts.compra'),
      venda: this.translate.instant('dashboard.texts.venda'),
      minimo: this.translate.instant('dashboard.texts.minimo'),
      sem_imagem: this.translate.instant('dashboard.texts.sem_imagem')
    };
  }
}
